/* eslint-disable */ 
import React from "react";
import _ from "lodash";
import { Responsive, WidthProvider } from "react-grid-layout";
import { ReportTable } from "./Table";
const ResponsiveReactGridLayout = WidthProvider(Responsive);

export class ReportsLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = { mounted: false };
  }
  componentDidMount() {
    this.setState({ mounted: true });
  }

  render() {
    // console.log("config\n", this.props.config);
    return (
      <div>
        <ResponsiveReactGridLayout
          {...this.props.config}
          className={"layout"}
          rowHeight={100}
          onLayoutChange={(layout, layouts) => {
            // console.log("this", this);
            this.props.updateconfig({
              layouts: Object.assign({}, this.props.config.layouts, {
                [this.props.config.currentBreakpoint]: layout
              })
            });
          }}
          // WidthProvider option
          measureBeforeMount={false}
          // I like to have it animate on mount. If you don't, delete `useCSSTransforms` (it's default `true`)
          // and set `measureBeforeMount={true}`.
          useCSSTransforms={this.state.mounted}
        >
          {this.props.reports.map((report, i) => {
            if (report)
              return (
                <div key={i}>
                  <ReportTable
                    {...this.props.reportProps}
                    config={report.config}
                    updateconfig={data =>
                      this.props.reportProps.upsert({
                        model: "RX_Report",
                        payload: {
                          id: report.id,
                          config: Object.assign({}, report.config, data)
                        }
                      })
                    }
                  />
                </div>
              );
          })}
        </ResponsiveReactGridLayout>
      </div>
    );
  }
}

// function generateLayout() {
//   return [
//     { x: 0, y: 0, w: 6, h: 5, i: "0", static: false },
//     { x: 6, y: 0, w: 6, h: 5, i: "1", static: false },
//     { x: 0, y: 5, w: 3, h: 4, i: "2", static: false },
//     { x: 6, y: 5, w: 9, h: 4, i: "3", static: false }
//   ];
// return _.map(_.range(0, 25), function(item, i) {
//   var y = Math.ceil(Math.random() * 4) + 1;
//   return {
//     x: (_.random(0, 5) * 2) % 12,
//     y: Math.floor(i / 6) * y,
//     w: 2,
//     h: y,
//     i: i.toString(),
//     static: Math.random() < 0.05
//   };
// });
// }

// <div>
//   Current Breakpoint: {this.state.currentBreakpoint} ({this.props.cols[this.state.currentBreakpoint]}{" "}
//   columns)
// </div>
// <div>
//   Compaction type:{" "}
//   {_.capitalize(this.state.compactType) || "No Compaction"}
// </div>
// <button onClick={this.onNewLayout}>Generate New Layout</button>
// <button onClick={this.onCompactTypeChange}>
//   Change Compaction Type
// </button>



// WEBPACK FOOTER //
// ./src/components/GridLayout.js